export default __webpack_public_path__ + "static/media/WNLhero.3228f139.jpg";